import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDmwe90TJKwF9YCti6tgoeFEDE0sKmOQpM",
  authDomain: "dictionary-9c858.firebaseapp.com",
  databaseURL: "https://dictionary-9c858.firebaseio.com",
  projectId: "dictionary-9c858",
  storageBucket: "dictionary-9c858.appspot.com",
  messagingSenderId: "793990078340",
  appId: "1:793990078340:web:66e3df8d5b5d68a7"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase 